// Libs
import React from "react";
import styled from "styled-components";
import { useQueryParam, StringParam } from "use-query-params";

// Components
import CategoryCard from "newDropshipperApp/pages/search/categoriesCards/CategoryCard";
import { Dropdown } from "newDropshipperApp/spocketUI";

// i18n
import { useTranslation } from 'react-i18next';

// Static Data
import {
  mainCategories,
  moreCategories
} from "./staticCategories";

// Images
import iconMore from "newDropshipperApp/images/icon-more.svg";

const CategoriesCards = ({ style }) => {
  const category = useQueryParam("category", StringParam);
  const setCategory = category[1];
  const { t } = useTranslation();

  return (
    <CategoriesCardsContainer style={style} className="intercom__categories-section">
      <HighlightCategory>
        <CategoryCard
          height={144}
          width={184}
          icon={mainCategories()[0].icon}
          onClick={() => setCategory(mainCategories()[0].name, "pushIn")}
        >
          {mainCategories()[0].label}
        </CategoryCard>
      </HighlightCategory>

      <RegularCategories>
        {mainCategories().map(category => {
          return (
            <RegularCategoryCard>
              <CategoryCard
                icon={category.icon}
                key={category.name}
                onClick={() => setCategory(category.name, "pushIn")}
              >
                {category.label}
              </CategoryCard>
            </RegularCategoryCard>
          );
        })}
        {/* START - More Categories Button */}
        <MoreCategoriesButton className="MoreCategoriesButton">
          <Dropdown>
            <Dropdown.Trigger>
              <CategoryCard key="more">
                <MoreCategoriesTitle>
                  <img src={iconMore} alt="category" />
                  { t("CategoriesCards.Label.MoreCategories") }
                </MoreCategoriesTitle>
              </CategoryCard>
            </Dropdown.Trigger>
            <Dropdown.Content>
              {moreCategories().map((category, index) => {
                return (
                  <Dropdown.Item
                    onClick={() => setCategory(category.name, "pushIn")}
                    key={index}
                  >
                    <MoreCategoriesWrap key={category.name}>
                      <MoreCategoriesIcon>{category.icon}</MoreCategoriesIcon>
                      <MoreCategoriesName>{category.label}</MoreCategoriesName>
                    </MoreCategoriesWrap>
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Content>
          </Dropdown>
        </MoreCategoriesButton>
        {/* END - More Categories Button */}
      </RegularCategories>
    </CategoriesCardsContainer>
  );
};

const CategoriesCardsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 24px;
`;

const HighlightCategory = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;

  @media (max-width: 1399px) {
    display: none;
  }
`;

const RegularCategories = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  margin: -16px 0 0 -16px;
  width: calc(100% + 16px);

  > div:first-of-type {
    display: none;
  }

  ${'' /* Control width on second to last item - the one before "More Categories" */}
  > div:nth-last-child(2) {
    max-width: 245px;

    @media (max-width: 370px) {
      max-width: none;
    }
  }

  @media (max-width: 1399px) {
    > div:first-of-type {
      display: inline-flex;
    }
  }

  @media (max-width: 800px) {
    justify-content: space-between;
    ::after {
      content: "";
      flex: auto;
    }
  }
`;

const RegularCategoryCard = styled.div`
  display: flex;
  flex-grow: 1;
  margin: 16px 0 0 16px;

  > div {
    width: 100%;
  }

  @media (max-width: 800px) {
    flex-grow: 0;
    width: 45%;
  }

  @media (max-width: 768px) {
    width: 30%;
  }

  @media (max-width: 600px) {
    width: 45%;
  }

  @media (max-width: 370px) {
    width: 100%;
  }
`;

const MoreCategoriesWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const MoreCategoriesTitle = styled.div`
  font-size: 16px;
  letter-spacing: 0.4px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: left;

  img {
    margin-right: 14px;
  }
`;

const MoreCategoriesIcon = styled.div`
  margin-right: 8px;
`;

const MoreCategoriesName = styled.div``;

const MoreCategoriesButton = styled.div`
  flex-grow: 1;
  margin: 16px 0 0 16px;
  max-width: 245px;
  button {
    width: 100%;
    > div {
      width: 100%;
    }
  }

  @media (max-width: 800px) {
    max-width: none;
    flex-grow: 0;
    width: 45%;
  }

  @media (max-width: 768px) {
    margin: 16px 0 0 4%;
    width: 30%;
  }

  @media (max-width: 600px) {
    margin: 16px 0 0 16px;
    width: 45%;
  }

  @media (max-width: 370px) {
    width: 100%;
  }
`;

export default CategoriesCards;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/CategoriesCards.js